module.exports = __webpack_public_path__ + "static/media/jara.fa5809e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/jara.png
// module id = 174
// module chunks = 0